var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PlotChange',{attrs:{"novel-id":_vm.novelId,"plotId":_vm.plotId,"plot":_vm.plot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }